import * as React from 'react';
import {
  handleBlurFormattedTextField,
  handleChangeFormattedTextField,
  handleFormattedTextFieldEffect,
} from 'ui/forms/formHelpers';
import { usePrevious } from '@tock/hooks';
import TextField, { TextFieldProps } from 'ui/TextField';
import _ from 'lodash';

export interface FormattedTextFieldProps extends TextFieldProps {
  filter: InputFilter;
}

/**
 * Use `FormattedTextField` applying a filter to a text field or text area
 *
 * ```js
 * import { FormattedTextField } from 'ui';
 * ```
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const FormattedTextField: React.FunctionComponent<
  React.PropsWithChildren<FormattedTextFieldProps>
> = ({ filter, value, onChange, onBlur, ...rest }) => {
  const [viewValue, setViewValue] = React.useState<string>(
    value && typeof value === 'string' && value.length > 0
      ? filter
        ? _.toString(filter.formatModelValue(value))
        : ''
      : ''
  );

  const prevValue = usePrevious(value);

  React.useEffect(
    () => handleFormattedTextFieldEffect(value, prevValue, filter, setViewValue),
    [filter, prevValue, value]
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleChangeFormattedTextField(event, filter, setViewValue, onChange);

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) =>
    handleBlurFormattedTextField(event, filter, setViewValue, onBlur);

  return (
    <TextField
      value={filter ? viewValue : value}
      {...rest}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default FormattedTextField;

// https://github.com/mui-org/material-ui/issues/13898 see for workaround for start adornment
// https://github.com/mui-org/material-ui/issues/11069 see for stuff about select and placeholder, also see NativeSelect component
